import API from "..";
import { checkAPIResponse } from "../helpers";

export class FeatureFlagApi {
  static async getFeatureFlags(): Promise<{ [key: string]: boolean }> {
    const api = await API();

    if (!api) {
      throw new Error("Failed to create an API instance");
    }

    const response = await api.get("/featureFlags");
    checkAPIResponse(response);

    return response.data.result ?? {};
  }
}
